import { render, staticRenderFns } from "./CustomizeMetalAM.vue?vue&type=template&id=923420b6&scoped=true"
import script from "./CustomizeMetalAM.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAM.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAM.vue?vue&type=style&index=0&id=923420b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923420b6",
  null
  
)

export default component.exports